<div class="sessionSearchParent">
    <!-- <h6 class="infoTextAdmin" *ngIf="ISUSNonUs">We love hearing about participant's experiences with Business Chemistry. <a href="https://amedeloitte.sharepoint.com/:w:/r/sites/DOL-c-US-BizChemHub/Nonfacilitator%20Drive/Admin%20Portal%20Toolkit/bc-session-feedback-guide-for-facilitators.docx?d=w03cb73ecc0784702a86ddf729fc6251d&csf=1&web=1&e=uE1S09" target="_blank">Learn more</a> about your role in gathering session feedback.</h6> -->
    <div class="row justify-content-md-center no-gutters greyBgBody marL10" (window:resize)="onResize($event)">
        <div class="col-12">
            <div class="row no-gutters">
              <div class="col-12 sessionAudienceSection whiteBg padb0 marL10">
                <div #searchFieldsHeight>
                  <h5 class="sectionTitleBig">
                    Session Search<span class="searchDrownArrow" *ngIf="seaerchAreaDownArrow"
                                        (click)="searchAreaExpand()">
                      <i class="fa fa-chevron-down"></i>
                    </span><span class="searchDrownArrow" *ngIf="seaerchAreaUpArrow"
                                 (click)="searchAreaCollapse()">
                      <i class="fa fa-chevron-up"></i>
                    </span>
                  </h5>
                  <span class="marB10">You will only see results for sessions where you are listed as a coordinator or facilitator.</span>
                  <div *ngIf="searchAreaFields">
                    <div>
                      <div class="row">
                        <div class="col-4">
                          <label for="sessionNameSearch">Session Name, ID or Display Name</label>
                          <input type="text" placeholder="" id="sessionNameSearch" [(ngModel)]="selectedSessionName"
                                 (ngModelChange)="onChangeOfInputFields(); validateFields()"
                                 (keyup.enter)="getSearchData()" />
                          <span class="errorMsgLabel" *ngIf="isSessionId">{{sessionErrorMsg}}</span>
                        </div>
                        <div class="col-4">
                          <label for="companyNameSearch">Company Name/Organization</label>
                          <input type="text" placeholder="" id="companyNameSearch" [(ngModel)]="selectedCompanyName"
                                 (ngModelChange)="onChangeOfInputFields(); validateFields()"
                                 (keyup.enter)="onFocusOutCompany($event);getSearchData()"
                                 [ngbTypeahead]="searchCompanies" [resultFormatter]="formatMatches"
                                 [inputFormatter]="formatMatches" (selectItem)="onCompanySelect($event)"
                                 [attr.value]="selectedCompanyName" (focusout)="onFocusOutCompany($event)" />
                          <span *ngIf="isCompName" class="errorMsgLabel">
                            {{compNameErrorMsg}}
                          </span>
                        </div>
                        <div class="col-4 editSessionDate">
                          <label>Session Date Range</label>
                          <div class="row sessionDateRange">
                            <div class="form-group col">
                              <div class="input-group">
                                <input class="form-control inputValFontSizeLineHeight br0"
                                       placeholder="mm-dd-yyyy" [(ngModel)]="startDate" name="dp"
                                       #dp="ngModel"
                                       (ngModelChange)="onStartDateSelect($event); onChangeOfInputFields()"
                                       ngbDatepicker #d1="ngbDatepicker" dateFormat="mm-dd-yyyy"
                                       (focusout)="onFocusOutDate()" (keyup.enter)="getSearchData()">
                                <div class="input-group-append">
                                  <button class="btn btn-outline-secondary calendar2 br0"
                                          (click)="d1.toggle()" type="button">
                                    <i class="fa fa-calendar"></i>
                                  </button>

                                </div>
                              </div>
                            </div>
                            <div class="form-group col">
                              <div class="input-group">
                                <input class="form-control inputValFontSizeLineHeight br0"
                                       placeholder="mm-dd-yyyy" [(ngModel)]="endDate"
                                       (ngModelChange)="onEndDateSelect($event); onChangeOfInputFields()"
                                       name="dp" ngbDatepicker #d2="ngbDatepicker"
                                       dateFormat="mm-dd-yyyy" (focusout)="onFocusOutDate()"
                                       (keyup.enter)="getSearchData()">
                                <div class="input-group-append">
                                  <button class="btn btn-outline-secondary calendar2 br0"
                                          (click)="d2.toggle()" type="button">
                                    <i class="fa fa-calendar"></i>
                                  </button>
                                  <span class="errorMsgLabel toDateErr" *ngIf="IsDateInvalid">
                                    {{invalidDateErrorMsg}}
                                  </span>
                                  <span class="errorMsgLabel bothDateError"
                                        *ngIf="showErrorMsgForBothDate">
                                    {{dateErrorMsg}}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <label for="facilitatorSearch">Facilitator(s)</label>
                          <input type="text" placeholder="" id="facilitatorSearch" [(ngModel)]="selectedFacilitator"
                                 (ngModelChange)="onChangeOfInputFields(); validateFields()"
                                 (keyup.enter)="getSearchData()" />
                          <span class="errorMsgLabel facilitatorErrorMsg"
                                *ngIf="isFacilitator">{{facilitatorErrorMsg}}</span>
                        </div>
                        <div class="col-4">
                          <label for="sessionCoordinatorSearch">Session Coordinator(s)</label>
                          <input type="text" placeholder="" id="sessionCoordinatorSearch" [(ngModel)]="selectedSessionCoordinator"
                                 (ngModelChange)="onChangeOfInputFields(); validateFields()"
                                 (keyup.enter)="getSearchData()" />
                          <span class="errorMsgLabel" *ngIf="isSessCoord">
                            {{sessCoordErrorMsg}}
                          </span>
                        </div>
                        <div class="col-2">
                          <label>Session Audience </label>
                          <div class="row rowAddedBorder no-gutters p0">
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsInternalDeloitte"
                                     (ngModelChange)="setSessionAudienceCheckboxValue(1, $event); onChangeOfInputFields();enableContentArea();"
                                     (keyup.enter)="getSearchData()" />Internal
                              Deloitte
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsClient"
                                     (ngModelChange)="setSessionAudienceCheckboxValue(2, $event); onChangeOfInputFields();enableContentArea();"
                                     (keyup.enter)="getSearchData()" />Client
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsNonClient"
                                     (ngModelChange)="setSessionAudienceCheckboxValue(3, $event); onChangeOfInputFields();enableContentArea();"
                                     (keyup.enter)="getSearchData()" />Non-client
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsMixedAudience"
                                     (ngModelChange)="setSessionAudienceCheckboxValue(4, $event); onChangeOfInputFields();enableContentArea();"
                                     (keyup.enter)="getSearchData()" />Mixed
                              Audience
                            </div>
                          </div>
                        </div>
                        <div class="col-2">
                          <label>Session Status</label>
                          <div class="row rowAddedBorder no-gutters p0">
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsToReview"
                                     (change)="setSessionStatusCheckboxValue(4, $event); onChangeOfInputFields()"
                                     [disabled]="!(IsClient || IsNonClient || IsMixedAudience)"
                                     (keyup.enter)="getSearchData()" />To Review
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsApproved"
                                     (change)="setSessionStatusCheckboxValue(1, $event); onChangeOfInputFields()"
                                     [disabled]="!(IsClient || IsNonClient || IsMixedAudience || IsInternalDeloitte)"
                                     (keyup.enter)="getSearchData()" />Approved
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsNotApproved"
                                     (change)="setSessionStatusCheckboxValue(2, $event); onChangeOfInputFields()"
                                     [disabled]="!(IsClient || IsNonClient || IsMixedAudience)"
                                     (keyup.enter)="getSearchData()" />Not Approved
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsCancelled"
                                     (change)="setSessionStatusCheckboxValue(3, $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Cancelled
                            </div>
                            <div class="col-12">
                              <input type="checkbox" [(ngModel)]="IsDraft"
                                     (change)="setSessionStatusCheckboxValue(5, $event); onChangeOfInputFields()"
                                     (keyup.enter)="getSearchData()" />Draft
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4" *ngIf="showSubscriptionId">
                          <label for="subscriptionIdSearch">Subscription ID</label>
                          <input type="text" placeholder="" id="subscriptionIdSearch" [(ngModel)]="selectedSubscriptionId"
                                 (ngModelChange)="onChangeOfInputFields()" (keyup.enter)="getSearchData()"
                                 (focusout)="onFocusOutSubscriptionID()" />
                        </div>
                      </div>

                    </div>











                    <div class="panel-group" id="accordion">
                      <div class=" panel panel-default">
                        <div class="collapse in show">
                          <div class="panel-body">
                            <div class="panel panel-default" id="tab1">
                              <div class="panel-heading "
                                   (click)="userRoleService?.closeAccordion('#collapse1')"
                                   [ngClass]="(userRoleID === 1 || userRoleID === 6) ? '' : 'advance-search-accordion'">
                                <h4 class="panel-title" (click)="ScrollIntoView('#tab1');">
                                  <a aria-expanded="false" aria-controls="collapse1"
                                     class="collapsed">
                                    Advanced
                                    Search
                                  </a>
                                </h4>
                              </div>


                              <div id="collapse1" class="accordion-collapse collapse"
                                   data-bs-parent="#accordion1">

                                <!-- <div id="collapse1" class="accordian-collapse collapse"> -->
                                <div class="panel-body">
                                  <div id="accordion1" class="col-12 advanced-search">
                                    <div class="row">
                                      <div class="col-4 mt25">
                                        <label for="select-sponsorCountry">Sponsoring Country/Location</label>
                                        <div class="form-group">
                                          <select class="form-control"
                                                  name="SponsorCountryID" id="select-sponsorCountry"
                                                  [(ngModel)]="selectedSponsoringCountry"
                                                  (ngModelChange)="onChangeOfInputFields();"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let country of sponsoringCountryList"
                                                    value={{country?.ID}}>
                                              {{country?.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4 mt25">
                                        <label for="select-sessionCountry">Session Country/Location</label>
                                        <div class="form-group">
                                          <select class="form-control"
                                                  name="SessionCountryID" id="select-sessionCountry"
                                                  [(ngModel)]="selectedSessionCountry"
                                                  (ngModelChange)="onChangeOfInputFields(); setSessionState()"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="0" hidden disabled selected>
                                            </option>
                                            <option *ngFor="let country of sessionCountryList"
                                                    value={{country?.ID}}>
                                              {{country?.Name}}
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4 mt25">
                                        <label for="select-sessionState">Session State</label>
                                        <div class="form-group">
                                          <select class="form-control" name="StateID" id="select-sessionState"
                                                  [(ngModel)]="selectedSessionState"
                                                  (ngModelChange)="onChangeOfInputFields()"
                                                  [disabled]="selectedSessionCountry != 23"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="0" hidden disabled selected>
                                            </option>
                                            <option *ngFor="let state of sessionStateList"
                                                    value={{state?.ID}}>
                                              {{state?.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4 mt15">
                                        <label for="select-sessionType">Session Type</label>
                                        <div class="form-group">
                                          <select class="form-control" name="TypeID" id="select-sessionType"
                                                  [(ngModel)]="selectedSessionType"
                                                  (ngModelChange)="onChangeOfInputFields(); onSessionTypeChange();enableContentArea();"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let type of sessionTypeList"
                                                    value={{type?.SessionTypeID}}>
                                              {{type?.SessionTypeName}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4 mt15">
                                        <label for="select-event">Event</label>
                                        <div class="form-group">
                                          <select class="form-control custom-select"
                                                  [disabled]="!showEventProgram"
                                                  name="eventID" id="select-event"
                                                  [(ngModel)]="sessionEventSelected"
                                                  (ngModelChange)="onChangeOfEvent(); onSessionEventChange();enableContentArea();"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let event of sessionEventFilterList"
                                                    value={{event?.eventID}}>
                                              {{event?.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4 mt15">
                                        <label for="select-program">Program</label>
                                        <div class="form-group">
                                          <select class="form-control"
                                                  [disabled]="!showEventProgram || !showProgramFinance"
                                                  name="programID" id="select-program"
                                                  [(ngModel)]="sessionProgramSelected"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let program of sessionProgramFilterList"
                                                    value={{program?.programID}}>
                                              {{program?.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <!--content area start-->
                                      <div class="col-4 mt15">
                                        <label for="select-contentArea">Content Area</label>
                                        <div class="form-group">
                                          <select class="form-control" name="ContentID" id="select-contentArea"
                                                  [(ngModel)]="selectedContentArea"
                                                  (ngModelChange)="onChangeOfInputFields(); onContentChange()"
                                                  (keyup.enter)="getSearchData()"
                                                  [disabled]="disableContentArea">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let type of contentAreaList"
                                                    [attr.selected]="type.ID==selectedContentArea?true:null"
                                                    value={{type?.ID}}>
                                              {{type?.ContentAreaName}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <!--content area end-->
                                      <!--topic start-->
                                      <div class="col-4 mt15">
                                        <label for="select-topic">Topic</label>
                                        <div class="form-group">
                                          <select class="form-control" name="TopicID" id="select-topic"
                                                  [(ngModel)]="selectedTopic"
                                                  (ngModelChange)="onChangeOfInputFields();"
                                                  (keyup.enter)="getSearchData()"
                                                  [disabled]="selectedContentArea != 2">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let type of TopicList"
                                                    value={{type?.ID}}>
                                              {{type?.TopicName}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <!--topic end-->
                                    </div>

                                    <div class="row">
                                      <div class="col-4">
                                        <label for="select-function">Service Line/Function</label>
                                        <div class="form-group">
                                          <select class="form-control" name="FunctionID" id="select-function"
                                                  [(ngModel)]="selectedFunction"
                                                  (ngModelChange)="onChangeOfInputFields()"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="0" hidden disabled selected>
                                            </option>
                                            <option *ngFor="let function of serviceFunctionList"
                                                    value="{{function?.ID}}">
                                              {{function?.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4">
                                        <label for="select-sessionFormat">Session Format</label>
                                        <div class="form-group">
                                          <select class="form-control" name="FormatID" id="select-sessionFormat"
                                                  [(ngModel)]="selectedSessionFormat"
                                                  (ngModelChange)="onChangeOfInputFields()"
                                                  (keyup.enter)="getSearchData()">
                                            <option value="null" hidden disabled
                                                    selected>
                                            </option>
                                            <option *ngFor="let format of sessionFormatList"
                                                    value={{format?.SessionFormatID}}
                                                    [hidden]="format?.SessionFormatID == 3 && (HighestRoleId != 5 && HighestRoleId != 1)">
                                              {{format?.SessionFormatName}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row separateLineTop horizontalLine">
                  <div class="col-6 txtLightColor">
                    <div class="countLabel" *ngIf="showTable">
                      {{totalNoRecords ? totalNoRecords: 0}} records
                    </div>
                    <div *ngIf="showTable">Maximum of 1000 Results will display</div>
                  </div>
                  <div class="col text-right">
                    <button *ngIf="totalNoRecords > 0 && seaerchAreaDownArrow" type="button" class="clickBtn"
                            (click)="searchAreaExpand()" [disabled]="!enableSearchBtn">
                      Modify search
                    </button>
                    <button *ngIf="totalNoRecords == 0 || !seaerchAreaDownArrow" type="button" class="clickBtn"
                            (click)="getSearchData()" [disabled]="!enableSearchBtn">
                      Search
                    </button>
                    <button type="button" class="clickBtn marL20" (click)="onClearSearch()"
                            [disabled]="!enableClearBtn">
                      Clear
                    </button>
                    <div class="text-right marT20">
                      <button type="button" class="clickBtn" [disabled]="!isEnableExportBtn"
                              (click)="exportData()">
                        Export Results
                      </button>
                      <button type="button" class="clickBtn column-picker-toggle marL20" (click)="toggleColumnSelector()" *ngIf="showTable && totalNoRecords > 0">
                        MANAGE GRID {{ visibleColumnCountLabel }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="column-picker" *ngIf="showTable && totalNoRecords > 0" #columnPickerContainer (document:click)="onDocumentClick($event)">
                 
                  <div class="column-picker-panel" *ngIf="isColumnSelectorOpen">
                    <div class="column-picker-header">
                      <div>
                        <button type="button" class="column-picker-link" [disabled]="!canResetColumnSelection"
                                (click)="resetColumnSelection()">Reset</button>
                        <button type="button" class="column-picker-link marL20" [disabled]="!canShowAllColumns"
                                (click)="showAllColumns()">Show all</button>
                        <button type="button" class="column-picker-link marL20" [disabled]="!canPinCurrentView"
                          (click)="pinCurrentView()">Save view</button>
                      </div>
                    </div>
                    <div class="column-picker-header">
                      <span>Choose columns</span>
                    </div>
                    <div class="column-picker-section">
                      <div class="column-picker-label">Always visible</div>
                      <label class="column-picker-option is-default" *ngFor="let column of defaultColumns">
                        <input type="checkbox" checked disabled />
                        <span>{{ column.header || column.name }}</span>
                      </label>
                    </div>
                    <div class="column-picker-section">
                      <div class="column-picker-label">More columns</div>
                      <ng-container *ngFor="let column of optionalColumns">
                        <label class="column-picker-option" *ngIf="(column.header !== 'Event Id') || userRoleID == 1">
                        <input type="checkbox"
                               [checked]="isAdditionalColumnSelected(column.name)"
                               (change)="onAdditionalColumnToggle(column.name, $event)" />
                        <span>{{ column.header || column.name }}</span>
                        </label>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="searchDataTable" [style.max-height]="searchGridHeight">
                  <app-loader-icon *ngIf="showLoaderIcon"></app-loader-icon>
                  <app-smart-data-grid *ngIf="showTable" [sampleColumns]="sampleColumns" [sampleData]="sampleData"
                                       [allowCheckbox]="allowCheckbox" [iseventRegistered]="true"
                                       [allowPagination]="allowPagination" [isClientSidePagination]="isClientSidePagination"
                                       (informParentComponent)="onRowSelect($event)" [totalRecord]="totalRecords"
                                       [pageSize]="pageSize"></app-smart-data-grid>
                  <!--(n) removed (handlePageChangeEvent)="updateListData($event)" (checkboxChangeEvent)="onCheckboxChange($event)"-->
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
